if ('vibrate' in navigator) {
	const inputs = document.querySelectorAll<HTMLInputElement>(
		'input[type="checkbox"], input[type="radio"]',
	);

	for (const input of inputs) {
		input.addEventListener('change', () => {
			navigator.vibrate(50);
		});
	}
}
